import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { BusinessProvider } from '@/context/BusinessContext'
import { Navigation } from '@/components/Navigation'
import { DocumentsPage, SuppliersPage, PromptsPage, UploadPage, BusinessesPage } from '@/pages'
import { AuthGate } from '@/auth/AuthGate'
import './App.css'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 seconds
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors
        if (error instanceof Error && 'status' in error) {
          const status = (error as { status: number }).status
          if (status >= 400 && status < 500) {
            return false
          }
        }
        return failureCount < 3
      },
    },
  },
})

function App() {
  return (
    <AuthGate>
      <QueryClientProvider client={queryClient}>
        <BusinessProvider>
          <BrowserRouter>
            <div className="min-h-screen bg-gray-50">
              <Navigation />
              <Routes>
                <Route path="/" element={<Navigate to="/documents" replace />} />
                <Route path="/documents" element={<DocumentsPage />} />
                <Route path="/documents/:documentId" element={<DocumentsPage />} />
                <Route path="/suppliers" element={<SuppliersPage />} />
                <Route path="/businesses" element={<BusinessesPage />} />
                <Route path="/prompts" element={<PromptsPage />} />
                <Route path="/upload" element={<UploadPage />} />
                <Route path="*" element={<Navigate to="/documents" replace />} />
              </Routes>
            </div>
          </BrowserRouter>
        </BusinessProvider>
      </QueryClientProvider>
    </AuthGate>
  )
}

export default App
